import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'rawHtml' })
export class RawHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(val: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(val);
  }
}
